/** Route in-app ouverte au tap d'une notification push. */
export type NotificationRoute = '/(tabs)' | '/(tabs)/quiz';

/**
 * Les payloads Expo/FCM arrivent parfois avec des valeurs toutes en string
 * (Android). On n'accepte que des écrans connus pour ne pas pousser une
 * route inexistante (`/challenge`) qui faisait échouer le cold start.
 */
export function getNotificationRoute(data: unknown): NotificationRoute {
  if (data == null || typeof data !== 'object') return '/(tabs)';
  const screen = 'screen' in data ? String((data as { screen?: unknown }).screen ?? '') : '';
  return screen === 'quiz' ? '/(tabs)/quiz' : '/(tabs)';
}
